// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-styles_header__N\\+fa6 {
    display: flex;
    height: var(--header-height);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(to bottom, #fbfbfb 50%, #f0f3f7 100%);
    z-index: 120;
    font-size: 16px;
}

.header-styles_wrapper__BSMvC {
    flex: 1 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*padding: 0 var(--header-padding-sides) 0 var(--sidebar-collapsed-width);*/
    /*padding: 0 0 0 var(--sidebar-collapsed-width);*/
    padding: 0 0 0 var(--sidebar-collapsed-width);
}

.header-styles_titleWrapper__0dseP {
    display: flex;
    align-items: center;
    padding-left: 30px;
}

.header-styles_nav__I0dqC {
    display: flex;
}

.header-styles_navItem__SwIlZ {
    text-decoration: none;
    font-weight: 700;
    position: relative;
}

.header-styles_navItem__SwIlZ:after {
    content: '';
    position: absolute;
    bottom: -2px;
    width: 100%;
    height: 2px;
    background: var(--hightlight-color);
    transform: scale(0);
    transition: transform 0.4s;
    left: 0;
}

.header-styles_navItem__SwIlZ.header-styles_active__gG0SP:after,
.header-styles_activeOpt__6NIjn:after {
    transform: scale(1);
}

.header-styles_navItem__SwIlZ:not(:last-child) {
    margin-right: 30px;
}

.header-styles_navItem__SwIlZ.header-styles_active__gG0SP,
.header-styles_activeOpt__6NIjn {
    color: var(--hightlight-color);
}

.header-styles_navItem__SwIlZ.header-styles_inactive__DDJsd {
    color: var(--light-grey);
    pointer-events: none;
}

.header-styles_title__BNPCH {
    /*margin-left: 73px;*/
}

.header-styles_title__BNPCH img {
    /*width: var(--header-logo-width);*/
    width: 120px;
}

.header-styles_login__YWzan,
.header-styles_titleWrapper__0dseP {
    width: 222px;
}

.header-styles_login__YWzan {
    text-align: right;
    position: relative;
    padding-right: 70px;
}

.header-styles_login__YWzan a {
    display: inline-flex;
    align-items: center;
    grid-gap: 16px;
}

.header-styles_login__YWzan a span {
    /*margin-right: 16px;*/
    display: block;
}

.header-styles_login__YWzan a:hover .header-styles_iconActive__oeDu\\+ {
    opacity: 1;
}

.header-styles_icon__yK4XK {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.header-styles_iconActive__oeDu\\+ {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    transition: opacity 0.4s;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .header-styles_header__N\\+fa6 {
        font-size: 18px;
    }

    .header-styles_title__BNPCH img {
        width: 147px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/components/Header/header-styles.module.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,iEAAiE;IACjE,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,2EAA2E;IAC3E,iDAAiD;IACjD,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,mCAAmC;IACnC,mBAAmB;IACnB,0BAA0B;IAC1B,OAAO;AACX;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":["@value screen-lg-min from '../../../breakpoints.css';\n\n.header {\n    display: flex;\n    height: var(--header-height);\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background: linear-gradient(to bottom, #fbfbfb 50%, #f0f3f7 100%);\n    z-index: 120;\n    font-size: 16px;\n}\n\n.wrapper {\n    flex: 1;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    /*padding: 0 var(--header-padding-sides) 0 var(--sidebar-collapsed-width);*/\n    /*padding: 0 0 0 var(--sidebar-collapsed-width);*/\n    padding: 0 0 0 var(--sidebar-collapsed-width);\n}\n\n.titleWrapper {\n    display: flex;\n    align-items: center;\n    padding-left: 30px;\n}\n\n.nav {\n    display: flex;\n}\n\n.navItem {\n    text-decoration: none;\n    font-weight: 700;\n    position: relative;\n}\n\n.navItem:after {\n    content: '';\n    position: absolute;\n    bottom: -2px;\n    width: 100%;\n    height: 2px;\n    background: var(--hightlight-color);\n    transform: scale(0);\n    transition: transform 0.4s;\n    left: 0;\n}\n\n.navItem.active:after,\n.activeOpt:after {\n    transform: scale(1);\n}\n\n.navItem:not(:last-child) {\n    margin-right: 30px;\n}\n\n.navItem.active,\n.activeOpt {\n    color: var(--hightlight-color);\n}\n\n.navItem.inactive {\n    color: var(--light-grey);\n    pointer-events: none;\n}\n\n.title {\n    /*margin-left: 73px;*/\n}\n\n.title img {\n    /*width: var(--header-logo-width);*/\n    width: 120px;\n}\n\n.login,\n.titleWrapper {\n    width: 222px;\n}\n\n.login {\n    text-align: right;\n    position: relative;\n    padding-right: 70px;\n}\n\n.login a {\n    display: inline-flex;\n    align-items: center;\n    grid-gap: 16px;\n}\n\n.login a span {\n    /*margin-right: 16px;*/\n    display: block;\n}\n\n.login a:hover .iconActive {\n    opacity: 1;\n}\n\n.icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.iconActive {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    opacity: 0;\n    transition: opacity 0.4s;\n}\n\n@media screen-lg-min {\n    .header {\n        font-size: 18px;\n    }\n\n    .title img {\n        width: 147px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"header": `header-styles_header__N+fa6`,
	"wrapper": `header-styles_wrapper__BSMvC`,
	"titleWrapper": `header-styles_titleWrapper__0dseP`,
	"nav": `header-styles_nav__I0dqC`,
	"navItem": `header-styles_navItem__SwIlZ`,
	"active": `header-styles_active__gG0SP`,
	"activeOpt": `header-styles_activeOpt__6NIjn`,
	"inactive": `header-styles_inactive__DDJsd`,
	"title": `header-styles_title__BNPCH`,
	"login": `header-styles_login__YWzan`,
	"iconActive": `header-styles_iconActive__oeDu+`,
	"icon": `header-styles_icon__yK4XK`
};
export default ___CSS_LOADER_EXPORT___;
